import { render, staticRenderFns } from "./BreadCrumbForum.vue?vue&type=template&id=30128b4e&scoped=true"
import script from "./BreadCrumbForum.vue?vue&type=script&lang=js"
export * from "./BreadCrumbForum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30128b4e",
  null
  
)

export default component.exports